module.exports = __webpack_public_path__ + "media/markers/powerb_blu-e547df24.svg";